export const QRCodeRegenerationStatus = {
  IN_PROGRESS: 'inprogress',
  DONE: 'done',
} as const
